import { render, staticRenderFns } from "./BundlePurchaseItemDetail.vue?vue&type=template&id=231f0215&"
import script from "./BundlePurchaseItemDetail.vue?vue&type=script&lang=ts&"
export * from "./BundlePurchaseItemDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports